//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableView', {
//        templateUrl: 'views/components/views/metaTableView/metaTableView.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'metaTableViewService', function ($stateParams, stateService, modalService, translateService, metaTableViewService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;
//            let metaTableViewKeyno = $stateParams.metatableview_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                metaTableViewKeyno: metaTableViewKeyno,
//                metaTableNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('translateedit', { item_id: vm.model.edit.word_id }) }
//                ],
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await metaTableViewService.getMetaTableView({
//                    metatable_keyno: metaTableKeyno,
//                    metatableview_keyno: metaTableViewKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                metaTableViewService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL
            
//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    metaTableViewService.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
